import { createUseStyles } from '@pff-consumer/tweed-ui/styles/create-use-styles'
import { ViewStyle } from 'react-native'

interface ProgressPaneStyles {
  container: ViewStyle
  iconContainer: ViewStyle
  header: ViewStyle
  message: ViewStyle
}

interface ProgressPaneStyleProps {
  isDesktop: boolean
}

export const useStyles = createUseStyles<ProgressPaneStyles, ProgressPaneStyleProps>((theme, props) => {
  return {
    container: {
      maxWidth: theme.calcUnit(295),
      margin: 'auto',
      marginTop: theme.calcUnit(props.isDesktop ? theme.spacing.s16 : theme.spacing.s10),
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center',
    },
    iconContainer: {
      marginTop: theme.calcUnit(theme.spacing.s12),
      padding: theme.calcUnit(theme.spacing.s2),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    header: {
      marginTop: theme.calcUnit(theme.spacing.s1),
    },
    message: {
      marginTop: theme.calcUnit(theme.spacing.s2),
    },
  }
})
